import React from 'react';
import Modal from '@/shared/components/Modal';
import { BodyText, H2 } from '@/shared/components/StyledText';
import styled, { css } from '@emotion/native';
import Button from '@/shared/components/Button';
import { sand, green } from '@/shared/styles/colors';
import ModalWrapper from '@/shared/styles/components/ModalWrapper';
import { Pressable } from 'react-native';

interface Props {
  isVisible: boolean;
  setIsVisible: (isVisible: boolean) => void;
  onDismiss: () => void;
  onExtendCall: () => void;
}

const TwoMinuteWarningModal = ({
  isVisible,
  setIsVisible,
  onDismiss,
  onExtendCall,
}: Props) => {
  return (
    <Modal
      isVisible={isVisible}
      setIsVisible={setIsVisible}
      isTransparent={true}
      style={customModalStyle}
    >
      <ModalWrapper style={{ ...containerStyle }}>
        <CloseButton onPress={onDismiss}>
          <CloseIcon source={require('@/assets/images/CloseGreen.png')} />
        </CloseButton>
        <Title>TIME&apos;S ALMOST UP</Title>
        <SubTitle>
          We&apos;re nearly out of time, but the looks are only getting better.
        </SubTitle>
        <ButtonContainer>
          <Button
            onPress={onExtendCall}
            text="Extend call"
            variant="primary"
            customStyle={extendCallButtonStyle}
          />
          <ItalicText>
            Extra minutes are billed per minute (up to 30 min)
          </ItalicText>
        </ButtonContainer>
      </ModalWrapper>
    </Modal>
  );
};

export default TwoMinuteWarningModal;

const containerStyle = css({
  width: '100%',
  backgroundColor: sand,
  borderRadius: 50,
  paddingHorizontal: 28,
  minHeight: 298,
  maxHeight: 320,
});

const customModalStyle = css({
  justifyContent: 'flex-end',
});

const CloseButton = styled(Pressable)({
  position: 'absolute',
  top: 29,
  right: 31,
  zIndex: 1,
});

const CloseIcon = styled.Image({
  width: 24,
  height: 24,
});

const Title = styled(H2)({
  marginBottom: 3,
  textTransform: 'uppercase',
  textAlign: 'center',
  color: green,
  fontSize: 30,
});

const SubTitle = styled(BodyText)({
  marginBottom: 23,
  fontSize: 18,
  lineHeight: 20,
  textAlign: 'center',
  color: green,
});

const ButtonContainer = styled.View({
  width: '100%',
  alignItems: 'center',
});

const extendCallButtonStyle = css({
  backgroundColor: green,
  marginBottom: 20,
  width: '100%',
});

const ItalicText = styled(BodyText)({
  fontSize: 14,
  lineHeight: 18,
  textAlign: 'center',
  color: green,
  fontStyle: 'italic',
  marginBottom: 23,
  paddingBottom: 20,
});
